(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/data/compressor.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/data/compressor.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getDefinitions() {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    return require('./definitions.es6').definitions;
  }

  return svs.accountservices.player_exclusions.definitions;
}

function getExclusion() {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    return require('./exclusion.es6');
  }

  return svs.accountservices.player_exclusions;
}

var _getDefinitions = getDefinitions(),
    verticals = _getDefinitions.verticals;

var _getExclusion = getExclusion(),
    Exclusion = _getExclusion.Exclusion;

var pauseLength = 18;

function padFront(num) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var result = String(num);

  while (result.length < length) {
    result = "0".concat(result);
  }

  return result;
}

function dateToString(expiry) {
  if (expiry) {
    var date = new Date(expiry);
    var year = date.getUTCFullYear() - new Date().getUTCFullYear();
    return "".concat(year >= 0 ? '+' : '').concat(Number(year).toString(36)).concat(Number(date.getUTCMonth() + 1).toString(36)).concat(date.getUTCDate().toString(36)).concat(date.getUTCHours().toString(36)).concat(padFront(Number(date.getUTCMinutes() * 60 + date.getUTCSeconds()).toString(36), 3));
  }

  return 'FFFFFFFF';
}

function stringToDate(expiry) {
  if (expiry && expiry !== 'FFFFFFFF') {
    var seconds = parseInt(expiry.substr(5, 3), 36);
    var year = new Date().getFullYear() + parseInt(expiry.substr(0, 2), 36);
    var month = padFront(parseInt(expiry.substr(2, 1), 36));
    var day = padFront(parseInt(expiry.substr(3, 1), 36));
    var hour = padFront(parseInt(expiry.substr(4, 1), 36));
    var minutes = padFront(Math.floor(seconds / 60));
    seconds = padFront(seconds % 60);
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minutes, ":").concat(seconds, ".0000000Z");
  }
}

function deflatePause(pause) {
  if (!pause) {
    return 'FFFFFFFF00FFFFFFFF';
  }

  return "".concat(dateToString(pause.expiry)).concat(pause.isExpired ? 1 : 0).concat(pause.type || 0).concat(dateToString(pause.selfTestExpiry));
} 


var deflate = function deflate() {
  var activeExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "".concat(activeExclusions.isBlocked ? 1 : 0).concat(deflatePause(activeExclusions.alla)).concat(deflatePause(activeExclusions.bingo)).concat(deflatePause(activeExclusions.casino)).concat(deflatePause(activeExclusions.poker)).concat(deflatePause(activeExclusions.sport));
};

function inflatePause(pauseString, vertical) {
  var expiry = stringToDate(pauseString.substr(0, 8));
  var isExpired = Boolean(parseInt(pauseString.substr(8, 1), 10));
  var type = expiry && parseInt(pauseString.substr(9, 1), 10);
  var selfTestExpiry = stringToDate(pauseString.substr(10, 8));
  var needSelfTest = Boolean(selfTestExpiry);

  if (expiry || selfTestExpiry) {
    return new Exclusion({
      expiry: expiry,
      isExpired: isExpired,
      needSelfTest: needSelfTest,
      selfTestExpiry: selfTestExpiry,
      type: type,
      vertical: vertical
    });
  }
} 


var inflate = function inflate(deflated) {
  var isBlocked = deflated.substr(0, 1) === '1';
  var alla = inflatePause(deflated.substr(1, pauseLength), verticals.ALLA);
  var bingo = inflatePause(deflated.substr(pauseLength + 1, pauseLength), verticals.BINGO);
  var casino = inflatePause(deflated.substr(pauseLength * 2 + 1, pauseLength), verticals.CASINO);
  var poker = inflatePause(deflated.substr(pauseLength * 3 + 1, pauseLength), verticals.POKER);
  var sport = inflatePause(deflated.substr(pauseLength * 4 + 1, pauseLength), verticals.SPORT);
  var exclusions = {
    hasPause: false,
    isBlocked: isBlocked
  };

  if (alla) {
    exclusions.alla = alla;
  }

  if (bingo || casino || poker || sport) {
    exclusions.hasVerticalPause = true;
  }

  exclusions.hasPause = Boolean(exclusions.hasVerticalPause || exclusions.alla);

  if (exclusions.hasPause) {
    exclusions.hasTotalPause = Boolean(exclusions.alla);
    exclusions.hasVerticalPause = Boolean(exclusions.hasVerticalPause);
  }

  if (bingo) {
    exclusions.bingo = bingo;
  }

  if (casino) {
    exclusions.casino = casino;
  }

  if (poker) {
    exclusions.poker = poker;
  }

  if (sport) {
    exclusions.sport = sport;
  }

  return exclusions;
};

var api = {
  deflate: deflate,
  inflate: inflate
};

if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  module.exports = api;
} else {
  svs.accountservices.player_exclusions.compressor = api;
}
 })(window);